export default {"src":"/_next/static/media/CARBON_INVENTORY_DISABLED_ICON.756abeaa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};